import { get } from '@api/request';

export const fetchMyQueues = async ({ queueService }, authenticationToken) => {
  const url = `${queueService}/queue/myqueues`;
  const { body } = await get(authenticationToken, url);
  return body;
};
